module.exports = __webpack_public_path__ + "static/media/kuro-markt-develop.0e04b424.svg";